<template>
	<div class="card">
		<div class="card-body">
			<CompanyCardMedium :company="company" :subtitle="subtitle" :placeholder="placeholder" :redirect="true" />
		</div>
	</div>
</template>

<script>
	import { computed } from 'vue';
	import moment from 'moment';

	export default {
		props: {
			company: Object,
			placeholder: {
				type: Boolean,
				default: false
			}
		},
		setup(props, { emit }) {
			const subtitle = computed(() => {
				if(props.company?.pivot?.created_at) return `Desde el ${moment(props.company.pivot.created_at).format('DD/MM/YYYY')}`
				else return null;
			});

			return { subtitle };
		}
	}
</script>